import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '出張費や見積もり費用はかかりますか？',
      answer: 'いいえ、出張費・見積もり費用は無料です。お気軽にご相談ください。ただし、一部の離島や遠隔地については別途ご相談させていただく場合がございます。',
    },
    {
      question: '対応エリアはどこですか？',
      answer: '東京都・神奈川県・埼玉県・千葉県を中心とした関東圏に対応しています。その他のエリアについても対応可能な場合がございますので、まずはお問い合わせください。',
    },
    {
      question: '急ぎの依頼にも対応してもらえますか？',
      answer: 'はい、可能な限り迅速に対応いたします。緊急の場合は、お電話にてご相談ください。状況に応じて、即日対応も可能です。',
    },
    {
      question: '支払い方法は何がありますか？',
      answer: '現金、銀行振込、各種クレジットカードに対応しています。サービス内容によっては、作業完了後のお支払いも可能です。詳しくはお見積もり時にご説明いたします。',
    },
    {
      question: '作業時間はどのくらいかかりますか？',
      answer: '作業内容や規模によって異なります。例えば、エアコンクリーニングは1台あたり1〜2時間、家財撤去は量によって半日〜1日程度です。お見積もり時に詳しくご説明いたします。',
    },
    {
      question: '土日祝日も対応していますか？',
      answer: 'はい、土日祝日も営業しています。年中無休で対応しておりますので、お客様のご都合に合わせてご予約いただけます。',
    },
    {
      question: '作業後の保証はありますか？',
      answer: 'はい、サービス内容に応じて保証期間を設けています。万が一、作業後に不具合が生じた場合は、無償で対応いたしますので、お気軽にご連絡ください。',
    },
    {
      question: '見積もり後にキャンセルできますか？',
      answer: 'はい、お見積もり後のキャンセルも可能です。キャンセル料は発生いたしませんので、ご安心ください。ただし、作業開始後のキャンセルについては、別途ご相談させていただきます。',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://static.readdy.ai/image/aec91cb01fdf30f00658c017aec0d8c9/c2243608c5ab6c5020c8b1778b649673.png)',
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/45"></div>
        
        <div className="relative z-10 text-center px-4">
          <h1 className="text-5xl md:text-6xl font-serif text-white mb-4">よくある質問</h1>
          <p className="text-lg text-white/90">FAQ</p>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-serif text-gray-800 mb-6">
              お客様からよくいただく<br className="md:hidden" />ご質問
            </h2>
            <p className="text-base text-gray-600 leading-relaxed">
              飛翠のサービスについて、お客様からよくいただくご質問をまとめました。<br />
              こちらに記載のない内容については、お気軽にお問い合わせください。
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-start gap-4 flex-1">
                    <div className="flex-shrink-0 w-8 h-8 bg-[#A7D676] rounded-full flex items-center justify-center">
                      <span className="text-sm font-bold text-white">Q</span>
                    </div>
                    <h3 className="text-base font-bold text-gray-800 leading-relaxed">
                      {faq.question}
                    </h3>
                  </div>
                  <i
                    className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-gray-600 flex-shrink-0 ml-4 transition-transform`}
                  ></i>
                </button>
                
                {openIndex === index && (
                  <div className="px-6 pb-5">
                    <div className="flex items-start gap-4 pl-12">
                      <div className="flex-1">
                        <div className="flex items-start gap-4">
                          <div className="flex-shrink-0 w-8 h-8 bg-[#76C7E1] rounded-full flex items-center justify-center">
                            <span className="text-sm font-bold text-white">A</span>
                          </div>
                          <p className="text-sm text-gray-700 leading-relaxed pt-1">
                            {faq.answer}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-4 bg-gradient-to-br from-[#A7D676]/10 to-[#76C7E1]/10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-serif text-gray-800 mb-6">
            その他のご質問は<br className="md:hidden" />お気軽にお問い合わせください
          </h2>
          <p className="text-base text-gray-600 mb-8 leading-relaxed">
            専門スタッフが丁寧にお答えいたします。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="bg-[#76C7E1] text-white px-8 py-4 rounded-full text-base font-medium hover:bg-[#65b6d0] transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
            >
              <i className="ri-mail-line text-xl mr-2"></i>
              お問い合わせフォーム
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
